import { Component } from '@angular/core';

@Component({
  selector: 'app-atlas-ai-logo',
  templateUrl: './atlas-ai-logo.component.html',
  styleUrls: ['./atlas-ai-logo.component.scss'],
})
export class AtlasAiLogoComponent {}
